import { render } from "./ExaminerDashboard.vue?vue&type=template&id=59d014c2&scoped=true"
import script from "./ExaminerDashboard.vue?vue&type=script&lang=js"
export * from "./ExaminerDashboard.vue?vue&type=script&lang=js"

import "./ExaminerDashboard.vue?vue&type=style&index=0&id=59d014c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d014c2"]])

export default __exports__